import React from 'react'

import { I18n } from '@front/volcanion'
import { TextField, DateField, TextPhoneInputField, SingleOptionSelectorField } from '@front/squirtle'

import { Typography, Grid, Box, StepLabel, StepContent } from '@mui/material'

const Blck1Row1 = ({ getDefaultDateTime }) =>
  <Grid container spacing={1} size={12}>
    <Grid size="grow">
      <DateField
        name={'info.birth_date'}
        label={I18n.t('driver.birth_date')}
        inputFormat={'DD/MM/YYYY'}
        defaultDateTime={getDefaultDateTime}
        disableOpenPicker
      />
    </Grid>
    <Grid size="grow">
      <TextField name='info.birth_place' label={I18n.t('driver.birth_place')} />
    </Grid>
    <Grid size="grow">
      <TextField name='info.nationality' label={I18n.t('driver.nationality')} />
    </Grid>
  </Grid>

const Blck1Row2 = props =>
  <Grid container spacing={1} size={12}>
    <Grid size="grow">
      <TextField
        name='driverinfo.driver_license'
        label={I18n.t('driver.driver_license')}
        _adornment={{ sx: { color: 'text.label', mb: '3px' } }}
        InputProps={{ startAdornment: I18n.t('id.number.maj') }}
      />
    </Grid>
    <Grid size="grow">
      <TextField
        name='driverinfo.id_card'
        label={I18n.t('driver.identity_card')}
        _adornment={{ sx: { color: 'text.label', mb: '3px' } }}
        InputProps={{ startAdornment: I18n.t('id.number.maj') }}
      />
    </Grid>
    <Grid size="grow">
      <TextField
        name='driverinfo.capacity_certif'
        label={I18n.t('driver.capacity_certif')}
        _adornment={{ sx: { color: 'text.label', mb: '3px' } }}
        InputProps={{ startAdornment: I18n.t('id.number.maj') }}
      />
    </Grid >
  </Grid>


const Blck2Row1 = ({ verifyEmail }) =>
  <Grid container spacing={1} size={12}>
    <Grid size="grow">
      <TextField name='info.address' label={I18n.t('address.label', { count: 1 })} />
    </Grid>
    <Grid size="grow">
      <TextField name='auth.email' label={I18n.t('email.label', { count: 1 })} type='email' afterUserChange={verifyEmail} required />
    </Grid>
  </Grid>

const Blck2Row2 = ({ defaultCountry, verifyGsm }) =>
  <Grid container spacing={1} size={12}>
    <Grid size="grow">
      <TextPhoneInputField
        name='auth.gsm'
        label={I18n.t('phone.gsm')}
        defaultCountry={defaultCountry}
        debounceTime={25}
        afterUserChange={verifyGsm}
        required
      />
    </Grid>
    <Grid size="grow">
      <SingleOptionSelectorField
        name={'auth.gsm_verified'}
        label={I18n.t('phone.gsm_verified')}
        clearOnEmpty={false}
      />
    </Grid>
    <Grid size="grow">
      <TextField name='info.tel' label={I18n.t('phone.label', { count: 1 })} />
    </Grid>
  </Grid >

const SecondarySection = ({ defaultCountry, verifyGsm, verifyEmail, getDefaultDateTime }) => <>
  <StepLabel>
    <Typography variant='h5'> {I18n.t('info.utils')} </Typography>
  </StepLabel>
  <StepContent >
    <Grid container spacing={2}>
      <Grid size={6}>
        <Box sx={{ p: 2, boxShadow: 6, borderRadius: 1 }}>
          <Grid container rowSpacing={1}>
            <Blck1Row1 getDefaultDateTime={getDefaultDateTime} />
            <Blck1Row2 />
          </Grid>
        </Box>
      </Grid>
      <Grid size={6}>
        <Box sx={{ p: 2, boxShadow: 6, borderRadius: 1 }}>
          <Grid container rowSpacing={1}>
            <Blck2Row1 verifyEmail={verifyEmail} />
            <Blck2Row2 defaultCountry={defaultCountry} verifyGsm={verifyGsm} />
          </Grid>
        </Box>
      </Grid>
    </Grid>
  </StepContent>
</>

export default React.memo(SecondarySection)
